// Ends the EMPLOYEE session — the one a rep holds on the /employee/* surfaces
// before they pick a customer to assist.
//
// A distinct thing from "Stop assisting", which ends an IMPERSONATION and hands
// the rep back their own employee session. This ends the employee session
// itself, so the magic-link sign-in is required to get back in.
//
// It exists as a component rather than inline because both employee surfaces
// need it and neither is inside the customer Layout that carries the ordinary
// sign-out. The backend route and the client call were already there; nothing
// rendered them, so an employee's only way out was to close the tab and let the
// token expire.

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import * as imp from '../api/impersonation.js';

export function EmployeeSignOut(): JSX.Element {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  return (
    <button
      type="button"
      className="link-button"
      disabled={pending}
      onClick={() => {
        setPending(true);
        void (async () => {
          // employeeLogout clears the local token in a `finally`, so a server
          // that never answered still leaves the browser signed out — the half
          // that matters on a shared machine.
          try {
            await imp.employeeLogout();
          } finally {
            navigate('/employee/login', { replace: true });
          }
        })();
      }}
    >
      {pending ? 'Signing out…' : 'Sign out'}
    </button>
  );
}
